import { render, staticRenderFns } from "./colAccionesBtnesUsuarios.vue?vue&type=template&id=6b4066d2&"
import script from "./colAccionesBtnesUsuarios.vue?vue&type=script&lang=js&"
export * from "./colAccionesBtnesUsuarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports